export const categories = {
  ad: 'ad',
  web: 'web',
};

export const actions = {
  trackingURLTimeout: 'hls.advanced.trackingURL.error.timeout',
  trackingURLError: 'hls.advanced.trackingURL.error', // append response code
  trackingURLEmpty: 'hls.advanced.trackingURL.empty.response',
  trackingURLStreamSwitch: 'hls.advanced.trackingURL.stream.switch',
  instreamPostTimeout: 'hls.advanced.post.error.timeout',
  instreamPostError: 'hls.advanced.post.error', // append response code
  instreamRequestTrackingDataError: 'instream.requestTrackingData.error',
  masterUrlTimeout: 'hls.advanced.masterUrl.error.timeout',
  masterUrlError: 'hls.advanced.masterUrl.error', // append response code
  mixedContentUpgrade: 'mixedContentUpgrade',
};

export const labels = {
  fail: 'fail',
  success: 'success',
};
